module.exports = __webpack_public_path__ + "img/logo.f66de628.png";